module.exports = __webpack_public_path__ + "static/main7-0d1465ac35018079cabd056bf55e91ae.png";